export default async (url, file) => {
  const response = await fetch(url, {
    method: 'PUT',
    body: file,
  });

  if (!response.ok) {
    throw new Error('Failed to upload file');
  }

  return {
    status: response.status,
    body: await response.text(),
  };
}
